import { Theme } from "@bps/fluent-ui";

export const EMPTY_LABEL = "(not set)";

export const getRootStyles = (
  theme: Theme,
  timePassed: boolean,
  showExpired?: boolean
) => {
  if (showExpired === false) return undefined;

  return {
    root: {
      color: timePassed ? theme.palette.red : theme.palette.green
    }
  };
};
